<div class="auth-title-text">
  {{ viewModel.authFlowTitle$ | async }}
</div>

<div class="auth-flow-subtext">
  {{ viewModel.authFlowSubtext$ | async }}
</div>

<form [formGroup]="formGroup" class="d-flex flex-column gap-4 mb-4">
  <div class="d-flex flex-column gap-2">
    <label for="email" class="form-input-label" i18n>Email</label>
    <app-email-input
      formControlName="email"
      controlId="email"
      [error]="formSubmitted && formGroup.controls.email.invalid" />
    <app-form-error
      *ngIf="formSubmitted && formGroup.controls.email.invalid"
      [errors]="formGroup.controls.email.errors" />
    <span class="form-input-hint">{{ hintText }}</span>
  </div>

  <div class="d-flex flex-column gap-2">
    <label for="password" class="form-input-label" i18n>New Password</label>
    <app-password-input
      formControlName="password"
      controlId="password"
      [error]="formSubmitted && formGroup.controls.password.invalid" />
    <app-form-error
      *ngIf="formSubmitted && formGroup.controls.password.invalid"
      [customErrorMessages]="customErrorMessages.password"
      [errors]="formGroup.controls.password.errors" />
    <span class="form-input-hint">{{ passwordHintText }}</span>
  </div>

  <div class="d-flex flex-column gap-2">
    <label for="confirmPassword" class="form-input-label" i18n>Confirm Password</label>
    <app-password-input
      formControlName="confirmPassword"
      controlId="confirmPassword"
      [error]="formSubmitted && formGroup.controls.confirmPassword.invalid" />
    <app-form-error
      *ngIf="formSubmitted && formGroup.controls.confirmPassword.invalid"
      [errors]="formGroup.controls.confirmPassword.errors" />
  </div>

  <div class="d-flex flex-column gap-2">
    <div class="eula-container">
      <app-checkbox-input formControlName="eulaAccepted" controlId="eulaAccepted" />
      <div class="d-flex align-items-center gap-1">
        <span class="non-terms-label" i18n>I accept the</span>
        <button type="button" (click)="viewModel.openEulaModal()" class="paddingless-text-button terms-label" i18n>
          Terms and Conditions
        </button>
      </div>
    </div>
    <app-form-error
      *ngIf="formSubmitted && formGroup.controls.eulaAccepted.invalid"
      [customErrorMessages]="customErrorMessages.eula"
      [errors]="formGroup.controls.eulaAccepted.errors" />
  </div>
</form>
<div class="d-flex justify-content-center align-items-center" i18n>
  <app-primary-button [style.width.%]="100" [width]="'100%'" (buttonClicked)="submit()">
    {{ 'Continue' }}
  </app-primary-button>
</div>
<div class="member-support-button-container" i18n>
  {{ 'Having trouble?' }}
  <button class="paddingless-text-button support-text mt-2" (click)="viewModel.openContactPage()">
    {{ 'Click here for support' }}
  </button>
</div>
